<div class="p-sub-column-layout02">
  <!-- [1.2.1] 支払情報サマリ -->
  <div class="p-sub-column-layout02__title p-sub-column-layout02__title--has-btn" *ngIf="showPaymentInforSummary">
    <!-- (1.2.2) 支払情報サマリタイトル -->
    <div class="p-heading-area01">
      <h2
        class="p-heading-area01__title c-heading-2"
        [innerHTML]="isAwardBooking ? ('heading.mileageTax' | staticMsg) : ('heading.price' | staticMsg)"
      ></h2>
    </div>
    <!-- (1.2.3) 支払情報詳細モーダル表示 -->
    <button
      class="c-btn-tertiary c-btn-tertiary--xs c-btn-tertiary--border-white"
      id="btn-payment-detail-id"
      (click)="openPaymentDetailsModal()"
    >
      <span class="c-btn-tertiary__text" [innerHTML]="'label.details' | staticMsg"></span>
    </button>
  </div>
  <!-- /[1.2.1] 支払情報サマリ -->
  <div class="p-sub-column-layout02__body">
    <!-- [1.2.1] 支払情報サマリ -->
    <div class="p-sub-column-layout02__body-item" *ngIf="showPaymentInforSummary">
      <div class="p-sub-column-layout02__payment">
        <div class="p-sub-column-layout02__payment-head">
          <dl class="c-float-list01">
            <!-- (1.2.4) 必要マイル -->
            <div class="c-float-list01__item" *ngIf="showRequiredMileage">
              <dt
                class="c-float-list01__title c-float-list01__title--em c-float-list01__title--gray90"
                [innerHTML]="'label.requiredMileage' | staticMsg"
              ></dt>
              <dd class="c-float-list01__contents c-float-list01__contents--fs16">
                <span class="c-amount c-amount--price">
                  <span
                    class="c-amount__num c-amount__num--fs24 c-amount__num--pc-fs28"
                    [innerHTML]="getRequiredMileage | milesFormat : 'currencyUnit.MIL'"
                  ></span>
                </span>
              </dd>
            </div>
            <div class="c-float-list01__item">
              <!-- (1.2.5) 支払総額ラベル -->
              <dt
                class="c-float-list01__title c-float-list01__title--em c-float-list01__title--gray90"
                [innerHTML]="getPaymentTotalLabel | staticMsg"
              ></dt>
              <!-- [1.2.6] 支払総額 -->
              <dd class="c-float-list01__contents c-float-list01__contents--fs16">
                <ng-container *ngFor="let item of getTotalPrices">
                  <div class="c-amount c-amount--price" [ngStyle]="isDifferentTotalPrices ? { color: 'red' } : {}">
                    <span
                      class="c-amount__num c-amount__num--fs24 c-amount__num--pc-fs28"
                      [attr.aria-label]="'reader.changeAmount' | staticMsg"
                    >
                      {{ item?.value ?? 0 | amountFormat : undefined : item?.currencyCode }}
                    </span>
                  </div>
                </ng-container>
              </dd>
              <!-- /[1.2.6] 支払総額 -->
            </div>
          </dl>
        </div>
        <div class="p-sub-column-layout02__payment-body" *ngIf="isHideBorderLinePaymentSummary">
          <dl class="c-float-list01">
            <!-- [1.2.10] 航空券金額情報 -->
            <ng-container *ngIf="showTicketTotalPrices">
              <!-- [1.2.11] 運賃総額 (航空券金額情報) -->
              <div [ngClass]="['c-float-list01__item']" *ngIf="showFareTotalPrices">
                <dt class="c-float-list01__title" [innerHTML]="'label.fareAndVariousCharge' | staticMsg"></dt>
                <dd class="c-float-list01__contents">
                  <ng-container *ngFor="let item of ticketPricesBase">
                    <div class="c-amount c-amount--price">
                      <span class="c-amount__num c-amount__num--fs18">{{
                        item?.value ?? 0 | amountFormat : undefined : item?.currencyCode
                      }}</span>
                    </div>
                  </ng-container>
                </dd>
              </div>
              <!-- /[1.2.11] 運賃総額 (航空券金額情報) -->
              <!-- [1.2.14] 税金総額 (航空券金額情報) -->
              <div class="c-float-list01__item">
                <dt class="c-float-list01__title" [innerHTML]="getLabelTaxTotalPrices | staticMsg"></dt>
                <dd class="c-float-list01__contents c-float-list01__contents--fs16">
                  <ng-container *ngFor="let item of getTaxTotalPrices">
                    <div class="c-amount c-amount--price">
                      <span class="c-amount__num c-amount__num--fs18">{{
                        item?.value ?? 0 | amountFormat : undefined : item?.currencyCode
                      }}</span>
                    </div>
                  </ng-container>
                </dd>
              </div>
              <!-- /[1.2.14] 税金総額 (航空券金額情報) -->
              <!-- [1.2.15] 発券手数料、交換発行手数料総 (航空券金額情報) -->
              <div class="c-float-list01__item">
                <dt class="c-float-list01__title" [innerHTML]="'label.fee' | staticMsg"></dt>
                <dd class="c-float-list01__contents" *ngIf="showTicketFeeTotalPrices; else TotalFeeShowZero">
                  <ng-container *ngFor="let item of ticketPricesTotalFee">
                    <div class="c-amount c-amount--price">
                      <span class="c-amount__num c-amount__num--fs18">{{
                        item?.value ?? 0 | amountFormat : undefined : item?.currencyCode
                      }}</span>
                    </div>
                  </ng-container>
                </dd>
                <!-- ※0でも表示する。 -->
                <ng-template #TotalFeeShowZero>
                  <dd class="c-float-list01__contents">
                    <div class="c-amount c-amount--price">
                      <span class="c-amount__num c-amount__num--fs18">
                        {{ 0 | amountFormat : undefined : currencyCodeByLang }}
                      </span>
                    </div>
                  </dd>
                </ng-template>
              </div>
              <!-- /[1.2.15] 発券手数料、交換発行手数料総 (航空券金額情報) -->
            </ng-container>
            <!-- /[1.2.10] 航空券金額情報 -->
          </dl>
        </div>
      </div>
    </div>
    <!-- /[1.2.1] 支払情報サマリ -->
    <asw-my-booking-slidebar-menu></asw-my-booking-slidebar-menu>
  </div>
</div>
